import { hasTokenCookie } from '@/lib/cookies';
import axios from '@/lib/axios';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

interface FavoriteCleanerData {
  favorite_id: string;
  cleaner_id: string;
  cleaner_name: string;
  cleaner_city: string;
  profile_pic: string;
  rating: number;
  no_of_reviews: number;
  is_favorite: boolean;
}

interface FavoriteCleanersListResponse {
  success: boolean;
  data: FavoriteCleanerData[];
}

const getUsersFavoriteCleanersListQuery =
  async (): Promise<FavoriteCleanersListResponse> => {
    const response = await axios.get('/users/favorite-cleaners');
    return response.data;
  };

export const usersFavoriteCleanersQueryKey = [
  'users',
  'favorite-cleaners',
] as const;

export const useGetUsersFavoriteCleanersListQuery = (
  options?: Partial<UseQueryOptions<FavoriteCleanersListResponse>>
) => {
  return useQuery({
    queryKey: usersFavoriteCleanersQueryKey,
    queryFn: getUsersFavoriteCleanersListQuery,
    retry: false,
    enabled: hasTokenCookie(),
    ...options,
  });
};
